module.exports = __webpack_public_path__ + "img/index10.1eba8c9f.svg";